import React from 'react'
import { PaymentsTable } from '@auteco/components/paymentComponents'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'

const LuciaPaymentsPage = () => {
    return (
        <div>
            <CardTitle title='Pagos pendientes por aprobar' />
            <PaymentsTable />
        </div>
    )
}

export { LuciaPaymentsPage }